/** Deterministic Guids matching backend CommunicationParameterGuids (EtlGuid). */
export const CommunicationParameterGuids = {
  home: "93b34422-e709-5bf2-b9e9-66da893e9a31",
  work: "7614402d-6acb-5c4d-8bb0-cacabf06363d",
  private: "d9e666b8-8642-54ef-8fa3-786a223669fb",
  /** Legacy CommunicationParameterEnum.Mobile = 12 — cep telefonu */
  mobile: "6e1c6c9f-af53-58bf-91c6-e509d44cf0c1",
  /** Legacy CommunicationParameterEnum.Rdc = 13 — corporate/system contact type */
  rdc: "12dcc99d-29e1-560b-8fa6-63e202441b42",
} as const;

/** Work + legacy RDC — corporate contact types regardless of display name. */
export const CORPORATE_COMMUNICATION_PARAMETER_IDS = new Set<string>([
  CommunicationParameterGuids.work.toLowerCase(),
  CommunicationParameterGuids.rdc.toLowerCase(),
]);

export const isCorporateCommunicationParameterId = (id: unknown): boolean => {
  if (id == null) return false;
  return CORPORATE_COMMUNICATION_PARAMETER_IDS.has(String(id).toLowerCase());
};
